import React from 'react';
import { Award, Users, Sparkles, Clock } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: '4.9⭐ Rating',
      description: 'Top-rated salon with 1200+ verified reviews',
    },
    {
      icon: Users,
      title: 'Expert Stylists',
      description: 'Skilled professionals with years of experience',
    },
    {
      icon: Sparkles,
      title: 'Premium Products',
      description: 'Only the best products for your beauty care',
    },
    {
      icon: Clock,
      title: 'Quick Service',
      description: 'No long waits, prompt appointments',
    },
  ];

  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Jayanagar's Most-Loved Beauty Destination
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            At Envoq Salon, we believe beauty is an art. Located in the heart of 1st Block Jayanagar, we've been transforming looks and boosting confidence with expert hair styling, nail artistry, skincare treatments, and premium beauty services. Our skilled team uses only the finest products to deliver personalized care that exceeds expectations.
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-[#f7f5f2] rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-accent-primary rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;